var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('van-tabs',{attrs:{"color":"#5A3232","ellipsis":false},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.data),function(item){return [_c('van-tab',{key:item.id,attrs:{"title":item.name,"name":item.id}})]})],2),_c('van-icon',{attrs:{"name":"apps-o"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }